const translations = {
  en: {
    h3Element: "Please check the preview carefully",
    emElement:
      "Make sure the below customization is correct to receive your item faster",
    atc: "ADD TO CART",
    
  },
  de: {
    h3Element: "Bitte prüfen Sie die Vorschau sorgfältig",
    emElement: "Ajouter au panier",
    atc: "In den Warenkorb",
    
  },
  es: {
    h3Element: "Por favor, revise la vista previa cuidadosamente",
    emElement:
      "Make sure the below customization is correct to receive your item faster",
    atc: "Añadir al carrito",
    
  },
  fr: {
    h3Element: "Veuillez vérifier l'aperçu attentivement",
    emElement:
      "Make sure the below customization is correct to receive your item faster",
    atc: "Ajouter au panier",
    
  },
  it: {
    h3Element: "Si prega di controllare attentamente l'anteprima",
    emElement:
      "Make sure the below customization is correct to receive your item faster",
    atc: "Aggiungi al carrello",
    
  },
  
  // 添加更多语言
};

// 检查 shopLocale 是否存在或是否有值，如果没有，则默认为 'en'
 if (typeof shopLocale === 'undefined' || !shopLocale || !(shopLocale in translations)) {
        shopLocale = 'en';
}
function translate(key) {
  return translations[shopLocale][key] || key;
}

const prevImageButtonDesktop = setInterval(() => {
    if(document.querySelectorAll('.customily-modal-preview-only').length){
      clearInterval(prevImageButtonDesktop);
      const button = document.createElement('div');
      const container = document.createElement('div');

      // 创建一个 <h3> 元素
const h3Element = document.createElement('h3');
h3Element.textContent = translate('h3Element');

     // 创建一个 <p> 元素
const pElement = document.createElement('p');
pElement.className = 'sub-content';
const emElement = document.createElement('em');
emElement.textContent = translate('emElement');
//pElement.appendChild(emElement);

// 获取 .customily-modal-preview-only 元素
const customilyModal = document.querySelector('.customily-modal-preview-only');

// 获取 .main 子元素
const mainElement = customilyModal.querySelector('.main');

      
 // Create the new div element
const newDiv = document.createElement('div');
newDiv.className = 'img-closed';
newDiv.id = 'preview-close';

// Create the img element
const newImg = document.createElement('img');
newImg.src = 'https://cdn.shopify.com/s/files/1/0775/7499/6246/files/Icon-closed.svg?v=1721496914';
newImg.width = 20;
newImg.height = 20;
newImg.alt = 'icon closed preview';

// Append the img element to the div
newDiv.appendChild(newImg);

// Append the new div to the main element
mainElement.insertBefore(newDiv,mainElement.firstChild);

      newDiv.addEventListener('click', function(){
        mainElement.querySelector('.customily-close-button').click();
        
      });

    // Select the customily close button
const closeButton = mainElement.querySelector('.customily-close-button');

// Forcefully hide the close button
if (closeButton) {
    closeButton.style.display = 'none';
}
    
      // 插入 <h3> 元素作为 .main 子元素的第一个子元素
//mainElement.insertBefore(h3Element, mainElement.firstChild);
  //    mainElement.insertBefore(pElement, mainElement.firstChild.nextElementSibling);
      

      
      //<h3>Please check the preview carefully</h3>
      //<p class="sub-content"><em>Make sure the below customization is correct to receive your item faster</em></p>
      container.style.background = '#ffffff';
      container.style.padding = '15px';
      container.style.width = '94vw';
      container.style.maxWidth = '600px';
      container.style.borderRadius = '20px';
      
      button.classList.add('button');
      button.classList.add('button--primary');
      button.classList.add('button--filled');
      button.classList.add('button--primary__filled');
      button.classList.add('ld-over-inverse');
      button.textContent = translate('atc');
      button.style.width = 'max-content';
      button.style.maxWidth = '100%';
      button.style.height = 'max-content';
      button.style.inset = '0';
      button.style.bottom = '0';
      
      button.style.margin = 'auto';
      button.style.fontSize = '1.5rem';
      if(window.innerWidth < 1150){
        button.style.marginTop = '10px';
      }else {
        button.style.marginTop = '10px';
      }
      button.addEventListener('click', function(){
        this.parentElement.parentElement.querySelector('.customily-close-button').click();
        document.getElementById('customily-cart-btn').click();
        
        setTimeout(function(){
          clearInterval(loader);
        }, 1000)
        
      });
      document.querySelector('.customily-modal-preview-only').querySelector('.main').app
      document.querySelector('.customily-modal-preview-only').style.padding = '10px 0';
      document.querySelector('.customily-modal-preview-only').style.justifyContent = 'center';
      document.querySelector('.customily-modal-preview-only').querySelector('.main').style.marginBottom = '10px';
      document.querySelector('.customily-modal-preview-only').querySelector('.main').appendChild(button);
      container.appendChild(document.querySelector('.customily-modal-preview-only').querySelector('.main'));
      document.querySelector('.customily-modal-preview-only').appendChild(container)
    }
  });
